import type { ReactNode } from "react";
import "./route-hero.css";

type RouteHeroProps = {
  eyebrow: ReactNode;
  title: string;
  description: string;
  aside: ReactNode;
};

/** The shared editorial frame used by the public catalogue routes. */
export function RouteHero({ eyebrow, title, description, aside }: RouteHeroProps) {
  return (
    <header className="v2-route-hero">
      <div className="v2-route-hero-copy">
        <span className="v2-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      {aside}
    </header>
  );
}

type RouteHeroMarkProps = {
  icon: ReactNode;
  caption: string;
  value?: string;
  ariaLabel?: string;
};

/** A compact diamond inside the same side plate as Market's ledger. */
export function RouteHeroMark({ icon, caption, value, ariaLabel }: RouteHeroMarkProps) {
  return (
    <div className="v2-route-hero-aside v2-route-hero-mark" aria-label={ariaLabel} aria-hidden={ariaLabel ? undefined : true}>
      <span className="v2-route-hero-diamond" aria-hidden>{icon}</span>
      {value ? <strong>{value}</strong> : null}
      <span className="v2-route-hero-mark-caption">{caption}</span>
    </div>
  );
}
